import { Select as AntSelect } from 'antd';
import type { FormField } from '../types';
import type { InputProps } from './types';

type SelectField = FormField & {
  options?: { label: string; value: string }[];
};

export function Select({ field, value, onChange, autoFocus }: InputProps) {
  const { options } = field as SelectField;
  return (
    <AntSelect
      value={(value as string) || undefined}
      onChange={(v) => onChange(v ?? null)}
      placeholder={field.placeholder || 'Select...'}
      autoFocus={autoFocus}
      disabled={field.disabled}
      className={field.inputClassName}
      style={{ width: '100%' }}
      options={options?.map((opt) => ({ label: opt.label, value: opt.value }))}
      allowClear
    />
  );
}
